export const EDIT_SUCCESS = 'Роль обновлена';
export const EDIT_ERROR = 'Не удалось обновить роль';
